





















































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: {
    },
    props: ['roDetails'],
})
export default class RepairOrderServiceDescription extends Vue {
    public constants: any = {
        storeId: 0,
        roNumber: '',
    };
}
